// 场地预定路由管理
// 菜单由后端权限接口下发：
//  - 场地侧「场地预定管理」权限链接 /site/manage（场地角色）
//  - 主办侧「场地预定查看」权限链接 /site/view（非场地 B 类角色）
// 路由 path 需与后端菜单 link 对齐，联调时确认
export default {
	path: 'site',
	name: 'site',
	component: () => import('@/components/RouterView'),
	redirect: '/manage/site/booking',
	meta: { title: '场地预定' },
	children: [
		{
			// 场地资料管理（含合作模式及报价）
			path: 'booking',
			name: 'siteBooking',
			component: () => import('@/views/manage/site/booking/index.vue'),
			meta: { title: '场地资料管理' }
		},
		{
			// 订场日历管理
			path: 'calendar',
			name: 'siteCalendar',
			component: () => import('@/views/manage/site/calendar/index.vue'),
			meta: { title: '订场日历管理' }
		},
		{
			// 接口凭证（开放接口 SK 申请，需求 7148298076）
			path: 'credential',
			name: 'siteCredential',
			component: () => import('@/views/manage/site/credential/index.vue'),
			meta: { title: '接口凭证' }
		},
		{
			// 开放接口在线文档（凭证页入口，需求 7148298076）
			path: 'credential/doc',
			name: 'siteCredentialDoc',
			component: () => import('@/views/manage/site/credential/doc.vue'),
			meta: { title: '接口文档' }
		},
		{
			// 来访记录
			path: 'visit',
			name: 'siteVisit',
			component: () => import('@/views/manage/site/visit/index.vue'),
			meta: { title: '来访记录' }
		},
		{
			// 主办侧·场地预定查看
			path: 'list',
			name: 'siteList',
			component: () => import('@/views/manage/site/organizer/list.vue'),
			meta: { title: '场地预定' }
		}
	]
}
